export const REDUCER_UPDATE_QUALITY = 'REDUCER_UPDATE_QUALITY';
